import React from 'react';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import Documents from './Documents';
import OlDocuments from './OlDocuments';
import Notifications from './Notifications';
import TeacherMailFieldsZS from './TeacherMailFieldsZS';

export default function DocumentsAndNotifications ({ updateOrders, formik }) {
  const { module } = useSelector(state => state.app);

  return (
    <Stack m={2} spacing={2}>
      {module === 'obozy' ? <OlDocuments updateOrders={updateOrders} formik={formik} /> : <Documents updateOrders={updateOrders} formik={formik} />}
      {module === 'zielone_szkoly' ? <TeacherMailFieldsZS formik={formik}/> : null}
      <Notifications formik={formik} />
    </Stack>
  );
};


